import { api } from '@creditsights/api-ui-web';
import { SearchBondsPayload } from '../../hooks/documents/useFetchBonds';
import { SearchLoansPayload } from '../../hooks/documents/useFetchLoans';
import { ListResult } from '../dtos/listResult';
import { SearchBondDto } from '../dtos/securities/searchBonds.dto';
import { SearchLoanDto } from '../dtos/securities/searchLoans.dto';

export const SECURITIES_MODULE_V1_URI = '/common/v1/securities';

export const fetchBonds = async (payload: SearchBondsPayload): Promise<ListResult<SearchBondDto>> => {
  const { data } = await api.post(`${SECURITIES_MODULE_V1_URI}/search/bonds`, payload);

  return data;
};

export const fetchLoans = async (payload: SearchLoansPayload): Promise<ListResult<SearchLoanDto>> => {
  const { data } = await api.post(`${SECURITIES_MODULE_V1_URI}/search/loans`, payload);

  return data;
};

export const fetchLoanDocument = async (fileName: string): Promise<Blob> => {
  const { data } = await api.get(`${SECURITIES_MODULE_V1_URI}/search/loans/files/${fileName}`, {
    responseType: 'blob',
  });

  return data;
};

export const fetchBondDocument = async (fileName: string): Promise<Blob> => {
  const { data } = await api.get(`${SECURITIES_MODULE_V1_URI}/search/bonds/files/${fileName}`, {
    responseType: 'blob',
  });

  return data;
};
